import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Routes as RouterRoutes, useLocation } from 'react-router-dom';
import withRouter from 'shared/helper/with-router';
import { loadInvoices } from './actions';
import InvoiceContainer from './components/InvoiceContainer';
import InvoiceFapiaoRequestContainer from './components/InvoiceFapiaoRequestContainer';
import InvoicePaymentContainer from './components/InvoicePaymentContainer';
import InvoiceRedirectContainer from './components/InvoiceRedirectContainer';
var Routes = function Routes(_ref) {
  var loadInvoices = _ref.loadInvoices;
  var _useLocation = useLocation(),
    state = _useLocation.state;
  useEffect(function () {
    loadInvoices((state === null || state === void 0 ? void 0 : state.orderNumber) || '');
  }, []);
  return /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: ":invoiceNumber/fapiao",
    element: /*#__PURE__*/React.createElement(InvoiceFapiaoRequestContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "pay/:invoiceNumbers",
    element: /*#__PURE__*/React.createElement(InvoicePaymentContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "unpaid/:type",
    element: /*#__PURE__*/React.createElement(InvoiceRedirectContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":status?",
    element: /*#__PURE__*/React.createElement(InvoiceContainer, null)
  }));
};
export default withRouter(connect(null, {
  loadInvoices: loadInvoices
})(Routes));